/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { date, DateFormat, entity } from '@gh/core-data';
import { CalendarDto, CalendarRequestDto } from './calendar.dto';

export const CalendarMapper = entity<CalendarDto>({
  deliveryDate: date(DateFormat.Date),
});

export const CalendarRequestMapper = entity<CalendarRequestDto>({});
